{
  "$id": "wealthlane://forms/plan-management/orch",
  "$schema": "wealthlane://schemas/form-orch",
  "layout": [
    {
      "rowId": "plan_details",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/name",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 200,
          "maxWidthPx": 500
        },
        {
          "scope": "#/properties/planTypeCategoryIds",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/boardApprovalDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        },
        {
          "scope": "#/properties/shareHolderApprovalDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/planEffectiveDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/poolId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        },
        {
          "scope": "#/properties/planTerm",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        },
        {
          "scope": "#/properties/evergreenPlan",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/evergreenCriteria",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/dividendEligibility",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        },
        {
          "scope": "#/properties/planExpiryDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/description",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 200,
          "maxWidthPx": 500,
          "startNewRow": true
        }
      ]
    },
    {
      "rowId": "termination_provisions_header",
      "title": "Termination Provisions",
      "titleStyle": "lozenge",
      "collapseWhenEmpty": true,
      "fields": [
        {
          "scope": "#/properties/optionExpirationDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        },
        {
          "type": "action-button",
          "actionId": "OPEN_TERMINATION_RULES_MODAL",
          "align": "start",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        }
      ]
    },
    {
      "rowId": "plan_allow_edit",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/allowEditPlanRelatedDocuments",
          "minCols": 2,
          "maxCols": 3,
          "minWidthPx": 200,
          "maxWidthPx": 600,
          "style": { "--ui-checkbox-label-size": "13px", "--ui-checkbox-label-lh": "1.4" },
          "startNewRow": true
        }
      ]
    },
    {
      "rowId": "plan_documents",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/planDocumentInput",
          "minCols": 3,
          "maxCols": 3,
          "minWidthPx": 200,
          "maxWidthPx": 600,
          "startNewRow": true
        }
      ]
    },
    {
      "rowId": "grant_documents_section",
      "title": "Grant Documents",
      "fields": [
        {
          "scope": "#/properties/grantAgreementDocs",
          "minCols": 3,
          "maxCols": 3,
          "minWidthPx": 200,
          "maxWidthPx": 800,
          "hideLabel": true
        },
        {
          "type": "action-button",
          "actionId": "OPEN_GRANT_AGREEMENT_MODAL",
          "align": "start",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        },
        {
          "scope": "#/properties/grantNoticeDocs",
          "minCols": 3,
          "maxCols": 3,
          "minWidthPx": 200,
          "maxWidthPx": 800,
          "hideLabel": true,
          "startNewRow": true
        },
        {
          "type": "action-button",
          "actionId": "OPEN_GRANT_NOTICE_MODAL",
          "align": "start",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        },
        {
          "scope": "#/properties/termsConditionDocDocs",
          "minCols": 3,
          "maxCols": 3,
          "minWidthPx": 200,
          "maxWidthPx": 800,
          "hideLabel": true,
          "startNewRow": true
        },
        {
          "type": "action-button",
          "actionId": "OPEN_TERMS_CONDITIONS_DOC_MODAL",
          "align": "start",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        },
        {
          "scope": "#/properties/termsConditionTextDocs",
          "minCols": 3,
          "maxCols": 3,
          "minWidthPx": 200,
          "maxWidthPx": 800,
          "hideLabel": true,
          "startNewRow": true
        },
        {
          "type": "action-button",
          "actionId": "OPEN_TERMS_CONDITIONS_TEXT_MODAL",
          "align": "start",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320,
          "startNewRow": true
        }
      ]
    }
  ]
}
